import { getStopApi } from '../../../services/StopApi/StopApi';

export const getCbpList = async ({ commonParams, authorization }) => {
  return await getStopApi({
    commonParams,
    authorization,
  }).then((response) => {
    const json = response.data;
    return {
      isLoading: false,
      total: response?.totalRows,
      data: json?.map((item, index) => ({
        ...item,
        id: index,
        CBPID: item.CBPID,
        mod: item.mod ? item.mod : '-',
        gnd: item.gnd ? item.gnd : '-',
        SAP: item.SAP,
        reg290: item.reg290,
        CCCMS: item.CCCMS,
        CCCEnhSer290: item.CCCEnhSer290,
        dataDeptComment: item.dataDeptComment ? item.dataDeptComment : '-',
        contractComplianceStatusComment: item.contractComplianceStatusComment
          ? item.contractComplianceStatusComment
          : '-',
        inactive: item.inactive,
        dedicatedCapacity: item.dedicatedCapacity,
        fundingSAP: item.fundingSAP ? item.fundingSAP.OrgKey : '-',
      })),
    };
  }).catch((e) => alert(e));
};

export const getCountyList = async ({ commonParams, authorization }) => {
  return await getStopApi({
    commonParams,
    authorization,
  }).then((response) => {
    return {
      isLoading: false,
      data: response.data,
      total: response.data.length
    }
  });
};
